export const APARTMENTS = [
  { id: 1, label: 'Apartament Fabryka Wody', description: 'Apartament przy Fabryce Wody' },
  { id: 2, label: 'Apartament Panorama', description: 'Apartament Panorama' },
];

export const DEFAULT_APARTMENTS = Object.fromEntries(APARTMENTS.map((item) => [item.id, {
  label: item.label,
  description: item.description,
}]));

export function getApartmentIds(user) {
  if (user?.role === 'admin') {
    return APARTMENTS.map((item) => item.id);
  }
  const raw = Array.isArray(user?.property_ids) && user.property_ids.length
    ? user.property_ids
    : user?.property_id != null
      ? [user.property_id]
      : [];
  return raw.map((value) => Number(value)).filter((value) => Number.isFinite(value));
}

export function apartmentLabel(id, apartments = APARTMENTS) {
  const match = apartments.find((item) => Number(item.id) === Number(id));
  return match?.label || `Apartament ${id}`;
}

export function apartmentSummary(ids, apartments = APARTMENTS) {
  const unique = Array.from(new Set((ids || []).map((value) => Number(value)).filter((value) => Number.isFinite(value))));
  return unique.map((id) => ({ id, label: apartmentLabel(id, apartments) }));
}

export function toggleSelection(list, value, checked) {
  const base = Array.isArray(list) ? list.map((item) => Number(item)).filter((item) => Number.isFinite(item)) : [];
  const id = Number(value);
  if (!Number.isFinite(id)) return base;
  if (checked) return Array.from(new Set([...base, id]));
  return base.filter((item) => item !== id);
}
